import User from '@/models/user'
export default class Chat {
  job_id = null
  job_name = null
  full_name = null
  message = null
  created_at = null

  constructor(data) {
    if (!data) return

    for (const key in data) {
      if (Object.keys(this).includes(key)) this[key] = data[key]
    }
  }

  get jobNameAvatar() {
    let user = new User({
      first_name: ' ',
      last_name: ' ',
    })

    if (!this.full_name) return user

    let splettedString = this.job_name.split(' ')
    user.first_name = splettedString[0] || ' '
    user.last_name = splettedString[1] || ' '

    return user
  }

  get formattedTime() {
    if (!this.created_at) return ''

    let isToday = () => {
      let today = new Date()
      let date = new Date(this.created_at)
      return today.toDateString() === date.toDateString()
    }

    let dateTime = this.created_at.split('T')
    let date = dateTime[0]
    let time = dateTime[1].split('.')[0].split(':').slice(0, 2).join(':')

    if (isToday()) return time
    return date
  }
}

export class ChatMessage {
  id = null
  user_id = null
  full_name = null
  first_name = null
  last_name = null
  sender_name = null
  message = null
  created_at = null
  updated_at = null
  file = null
  payload = null

  constructor(data) {
    if (!data) return

    for (const key in data) {
      if (Object.keys(this).includes(key)) this[key] = data[key]
    }

    this.user_id =
      this.user_id ||
      data.user?.id ||
      data.sender?.id ||
      data.author?.id ||
      data.client?.id ||
      data.expert?.id ||
      null

    this.first_name =
      this.first_name ||
      data.user?.first_name ||
      data.sender?.first_name ||
      data.author?.first_name ||
      data.client?.first_name ||
      data.expert?.first_name ||
      null

    this.last_name =
      this.last_name ||
      data.user?.last_name ||
      data.sender?.last_name ||
      data.author?.last_name ||
      data.client?.last_name ||
      data.expert?.last_name ||
      null

    this.sender_name =
      this.sender_name ||
      data.user?.full_name ||
      data.sender?.full_name ||
      data.author?.full_name ||
      data.client?.full_name ||
      data.expert?.full_name ||
      data.user_name ||
      data.sender_name ||
      null

    this.full_name = this.full_name || this.sender_name
    if (!this.full_name && (this.first_name || this.last_name)) {
      this.full_name = `${this.first_name || ''} ${this.last_name || ''}`.trim()
    }
  }

  get user() {
    let user = new User({
      first_name: this.first_name || ' ',
      last_name: this.last_name || ' ',
    })

    return user
  }

  get getShortName() {
    return `${(this.first_name || '')[0]}${(this.last_name || '')[0]}`
  }

  get getDateOrToday() {
    if (!this.created_at) return ''

    let isToday = () => {
      let today = new Date()
      let date = new Date(this.created_at)
      return today.toDateString() === date.toDateString()
    }

    if (isToday()) return 'Today'
    return this.created_at.split('T')[0]
  }

  get formattedTime() {
    if (!this.created_at) return ''

    let isToday = () => {
      let today = new Date()
      let date = new Date(this.created_at)
      return today.toDateString() === date.toDateString()
    }

    let dateTime = this.created_at.split('T')
    let date = dateTime[0]
    let time = dateTime[1].split('.')[0].split(':').slice(0, 2).join(':')

    if (isToday()) return time
    return date + ' ' + time
  }
}
